import React, { useCallback } from 'react';
import { BaseFilter } from '../BaseFilter';
import { Popup } from '../../Popup';
import { Button } from '../../../atoms/Button';
import './BooleanFilterStyles.scss';
function getSelectedDisplay(value, trueLabel, falseLabel, allLabel, persistAllSelection) {
    if (value === true)
        return trueLabel;
    if (value === false)
        return falseLabel;
    if (persistAllSelection && value === null)
        return allLabel;
    return undefined;
}
/**
 * BooleanFilter
 * Three-state filter (true / false / null) rendered as a BaseFilter popup
 * with an ActionList containing Yes / No / All options.
 * @version 1.0.0
 * @since 2026-05-04
 */
export function BooleanFilter({ label, value, onChange, trueLabel = 'Yes', falseLabel = 'No', allLabel = 'All', disabled = false, showReset = true, persistAllSelection = false }) {
    const selectedDisplay = getSelectedDisplay(value, trueLabel, falseLabel, allLabel, persistAllSelection);
    const handleSelect = useCallback((v, close) => {
        onChange(v);
        close();
    }, [onChange]);
    const handleReset = useCallback(() => onChange(null), [onChange]);
    return (React.createElement(BaseFilter, { label: label, isActive: value !== null || persistAllSelection, selectedDisplay: selectedDisplay, disabled: disabled, onReset: showReset && value !== null ? handleReset : undefined }, (close) => (React.createElement(Popup.ActionList, { className: "qmb-ui-boolean-filter__action-list" },
        React.createElement(Button, { className: "qmb-ui-boolean-filter__option", "aria-pressed": value === true, onClick: () => handleSelect(true, close) }, trueLabel),
        React.createElement(Button, { className: "qmb-ui-boolean-filter__option", "aria-pressed": value === false, onClick: () => handleSelect(false, close) }, falseLabel),
        React.createElement(Button, { className: "qmb-ui-boolean-filter__option", "aria-pressed": value === null, onClick: () => handleSelect(null, close) }, allLabel)))));
}
